
import React from "react";
import "./Services.css";

const servicesList = [
  {
    title: "Corporate Security Guards",
    description: "We secure businesses across all industry segments with tailored security solutions for seamless operations consistently.",
    image: require("../assets/services/guard.jpg")
  },
  {
    title: "Administrative Support",
    description: "We provide trained receptionists, secretaries, computer professionals & office assistants to support your backend operations.",
    image: require("../assets/services/admin.jpg")
  },
  {
    title: "Factories & Warehouses Security",
    description: "Specialized guards secure remote facilities from theft, vandalism, and unauthorized access. We design custom protection plans after thorough survey of site visits.",
    image: require("../assets/services/Warehouse.jpg")
  },
  {
    title: "Housekeeping Services",
    description: "Comprehensive housekeeping from floor care, deep cleaning, garden maintenance, and more to maintain high standards with basic etiquittes.",
    image: require("../assets/services/HK.jpg")
  },
  {
    title: "Retail Security",
    description: "Retail outlets are safeguarded with theft-prevention protocols, shoplifting detection, and distraction-based theft prevention.",
    image: require("../assets/services/electronics_store.jpg")
  },
  {
    title: "Crowd Control Management",
    description: "Expert crowd control for events with services like ushers, line control, ticket takers, guest reps, and tactical response teams.",
    image: require("../assets/services/Crowd.jpg")
  },
  {
    title: "Fire Safety & Dog Squads",
    description: "Specialized teams with dog squads and fire safety experts ensure rapid response to emergencies and secure high-risk zones.",
    image: require("../assets/services/Fire.jpg")
  },
  {
    title: "Electronic Alarms & Metal Detectors",
    description: "We provide advanced electronic alarm systems, intruder detection, and metal detectors for complete entry control and surveillance.",
    image: require("../assets/services/Alarm.jpg")
  },
  {
    title: "Manpower Outsourcing",
    description: "We support clients with trained personnel including ushers, and guest service reps across sectors like hospitality services, malls, and events.",
    image: require("../assets/services/MPO.jpg")
  }
];

const Services = () => {
  return (
    <section className="services-section">
      <div className="services-image">
        {/* <img src={servicesImage} alt="Security Services" /> */}
      </div>
      <div className="services-list">
        <h2>Our Services</h2>
        {servicesList.map((service, index) => (
  <div className="service-item" key={index}>
    <div className="service-image">
      <img src={service.image} alt={service.title} />
    </div>
    <div className="service-text">
      <h3>{service.title}</h3>
      <p>{service.description}</p>
    </div>
  </div>
))}
      </div>
    </section>
  );
};

export default Services;
